/**
 * axiosSetup — Global axios konfigürasyonu (baseURL + auth interceptor).
 *
 * Neden ayrı dosya (2026-05-16 derleme fix):
 *   _app.js'in top-level import zinciri /_error sayfasına kadar compile graph'a
 *   giriyordu. axios + supabase setup'ı _app.js'den izole etmek, _app.js'in
 *   bundle dependency'sini minimum tutar.
 *
 * Side-effect: bu dosyanın import edilmesi yeterli — `axios.defaults` ve
 * `axios.interceptors` modül-scope'da set edilir.
 *
 * @module shared/utils/axiosSetup
 */

import axios from 'axios';
import { supabase } from '@/shared/utils/supabaseClient';
import { API_BASE_URL } from '@/config';
import { baglantiYenidenDeneKur } from '@/shared/utils/baglantiYenidenDene';

// Tüm istekler backend'e yönlendirilsin
axios.defaults.baseURL = API_BASE_URL;

// GET bağlantı hatasında bir kez daha (TR erişim kesintisi, 22 Eki) — bkz baglantiYenidenDene
baglantiYenidenDeneKur(axios);

// Her istekte Supabase token'ı Authorization header'ına ekle
axios.interceptors.request.use(
  async (config) => {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    } catch {
      return config;
    }
  },
  (error) => Promise.reject(error)
);
